
const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';
const UPDATING_NOTIFICATIONS = 'UPDATING_NOTIFICATIONS';
const UPDATED_NOTIFICATIONS = 'UPDATED_NOTIFICATIONS';
const UPDATE_NOTIFICATIONS_FAILED = 'UPDATE_NOTIFICATIONS_FAILED';

const initialState = {
  _processing: false,
  notifications: {}
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATING_NOTIFICATIONS: {
      return {
        ...state,
        _processing: true
      };
    }
    case UPDATED_NOTIFICATIONS: {
      return {
        ...state,
        notifications: action.result,
        _processing: false
      };
    }
    case UPDATE_NOTIFICATIONS_FAILED: {
      return {
        ...state,
        _processing: false
      };
    }
    default:
      return state;
  }
}

export const actions = {
  updateNotificationSettings(payload, onSuccess, onFailure) {
    return {
      type: UPDATE_NOTIFICATIONS,
      types: [UPDATING_NOTIFICATIONS, UPDATED_NOTIFICATIONS, UPDATE_NOTIFICATIONS_FAILED],
      callApi: client => client.post('/user/settings', { notifications: payload }),
      onSuccess: onSuccess ? [onSuccess] : [],
      onFailure: onFailure ? [onFailure] : []
    };
  },
};

export const selectors = {
  getNotificationSettings(state) {
    const { _processing, notifications } = state.settings;
    return { _processing, notifications };
  }
};
